/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum OrganizationRawMaterialAttributeKeyGroup {
  PHYSICOCHEMICAL_PROPERTIES = "physicochemical_properties",
  USAGE_GUIDELINES = "usage_guidelines",
  BENEFITS = "benefits",
  CLINICAL_TESTS = "clinical_tests",
  REGULATORY = "regulatory",
  REGULATORY_COMPLIANCE = "regulatory_compliance",
  REGULATORY_ETHICAL_RELIGIOUS_SUSTAINABILITY = "regulatory_ethical_religious_sustainability",
  REGULATORY_FREE_FROM = "regulatory_free_from",
  REGULATORY_MANUFACTURING_AND_PROCESS = "regulatory_manufacturing_and_process",
  REGULATORY_ISO16128 = "regulatory_iso16128",
}
